module.exports = __webpack_public_path__ + "img/SDG-08-EN-INVERTED.f067efa9.png";